import { withAnalyticOnView } from 'react-shisell';

export const withPageViewAnalytic = <T extends Record<string, {externalId: string}>>() =>
  withAnalyticOnView<T>({
    analyticName: 'PageView',
    mapPropsToIdentities: ({ user }) => ({ ExternalId: user?.externalId }),
  });
